import store from '../store/index.js'

export default {
    methods: {
        hasPermission: (action, model=null, app=null) => {
            let res = undefined

            if (action && model == null && app == null) {
                // call in component => this.hasPermission('add_country')
                res = store.getters.user.permissions?.find(p => p.action == action)
            } else if (action && model && app == null) {
                // call in component => this.hasPermission('add_country', 'country')
                res = store.getters.user.permissions?.find(p => (p.action == action && p.model == model))
            } else if (action && model && app) {
                // call in component => this.hasPermission('add_country', 'country', 'setting')
                res = store.getters.user.permissions?.find(p => (p.action == action && p.model == model && p.app == app))
            }
 
            return (res != undefined) // true or false
        },
    },
}